import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { RolePrivilegeSelectionComponent } from './role-privilege-selection/role-privilege-selection.component';
import { DataTableComponent } from '../../../components/data-table/data-table.component';
import { RoleHasPrivilegesService } from '@services/roles/role-has-privileges.service';
import * as _ from 'lodash'

@Component({
    selector: 'app-profile-role-manager',
    templateUrl: './role-privilege-manager.component.html',
    styleUrls: ['./role-privilege-manager.component.scss'],
    providers: [RoleHasPrivilegesService],
    standalone: false
})
export class RolePrivilegeManagerComponent implements OnInit {

  public title = 'Role Privilege Manager';
  headerButtons = [{ icon: 'add', callback: () => {return this.addPrivilege()} }];
  @Input() id: string;
  params: any;

  @ViewChild(DataTableComponent) table: DataTableComponent;
  columns = [
    { prop: 'privilegeName' },
    { prop: 'value' }
  ];

  constructor(
    public roleHasPrivilegesService: RoleHasPrivilegesService,
    private dialog: MatDialog,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    if (this.id) {
      this.params = { RoleID: this.id }
    } else {
      this.params = { RoleID: this.route.snapshot.params['id'] };
    }
  }

  addPrivilege() {
    const dialogRef = this.dialog.open(RolePrivilegeSelectionComponent, {
      width: '600px',
      data: null
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.values && result.values.length) {
        const data = new Models.RoleHasPrivilege();
        result.values.map((value: string) => {
          if (value && value.length) {
            data.populateFromJSON({
              ID: undefined,
              RoleID: this.params.RoleID,
              PrivilegeID: result.PrivilegeID,
              value: _.trim(value)
            });
            this.create(data);
          }
        })
      }
    });
  }

  onRemove(event: any) {
    this.remove(event.row.ID).then(() => {
      this.ngOnInit();
    });
  }

  onEdit(event: any) {
    const dialogRef = this.dialog.open(RolePrivilegeSelectionComponent, {
      width: '600px',
      data: { roleHasPrivilege: event.row, edit: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.PrivilegeID && result.value) {
        const data = new Models.RoleHasPrivilege();
        data.populateFromJSON({
          ID: undefined,
          RoleID: this.params.RoleID,
          PrivilegeID: result.PrivilegeID,
          value: _.trim(result.value)
        });
        this.remove(result.id).then(() => {
          this.create(data);
        })
      }
    });
  }

  create(data) {
    this.roleHasPrivilegesService.create(data).then(() => {
      this.table.refresh();
    });
  }

  remove(id) {
    return this.roleHasPrivilegesService.remove(id);
  }

}
